import React, { FC } from 'react'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { CopyEmail } from '../CopyEmail'
import video from '../../../images/contact/inner.mp4'
import img from '../../../images/contact/img1.svg'

const useStyle = makeStyles((theme: Theme) => ({
  container: {
    textAlign: 'center',

    marginRight: 0,
    color: '#fff',
    marginTop: 176,
  },
  animationBack: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '50%',
    minHeight: '100%',
    background: '#584de2',
  },
  animation: {
    position: 'fixed',
    zIndex: 0,
    top: '50%',
    right: '50%',
    transform: 'translate(100%, -50%)',
    width: '50%',
    height: '100%',
    opacity: '50%',
    objectFit: 'cover',
  },
  animationAbove: {
    position: 'fixed',
    minHeight: '100%',
    background: '#0B0097',
    opacity: '60%',
  },
  section: {
    position: 'relative',
    textAlign: 'left',
    zIndex: 1,
    paddingLeft: 96,
    paddingTop: 129,
    borderTop: '1px solid rgba(255,255,255,0.32)',
  },
  content: {
    maxWidth: 496,
  },
  title: {
    marginBottom: 74,
    textAlign: 'left',
  },
  text: {
    fontSize: 16,
    letterSpacing: 'normal',
    fontWeight: 500,
    paddingBottom: theme.spacing(4),
  },
  svg: {
    marginTop: theme.spacing(8),
  },
}))

export const RightPanel: FC = () => {
  const classes = useStyle()
  return (
    <Grid className={classes.container}>
      <Grid container className={classes.animationBack}>
        <video id="background-video" loop autoPlay muted className={classes.animation}>
          <source src={video} type="video/mp4" />
          <source src={video} type="video/ogg" />
          Your browser does not support the video tag.
        </video>

        <Grid container className={classes.animationAbove} />
      </Grid>

      <Grid container className={classes.section}>
        <Grid className={classes.content}>
          <Typography variant="h1" className={classes.title}>
            Talk to us Today
          </Typography>

          <Typography variantMapping={{ body1: 'p' }} className={classes.text}>
            You can fill out the form on the left or just click on the button below for a more detailed email. We will
            answer within 24 hours.
          </Typography>

          <CopyEmail />
          <img src={img} alt="img1" className={classes.svg} />
        </Grid>
      </Grid>
    </Grid>
  )
}
